import React from 'react';

import type { TargetingPreset } from '../../../apis/graphql';
import type { Nullable, TargetingTermValue } from '../../../models';
import { TargetingPanel } from '../../Targeting';

type TargetingPresetDetailsProps = {
  targetingPreset: Nullable<TargetingPreset>;
};

const TargetingPresetDetails = ({ targetingPreset }: TargetingPresetDetailsProps): JSX.Element => {
  const targetingTermValues = (targetingPreset?.definition || []) as TargetingTermValue[];

  return (
    <div>
      <h1>{targetingPreset?.name || ''}</h1>
      <p>{targetingPreset?.description || ''}</p>
      <TargetingPanel
        isTableToggleable={false}
        targetingPreset={targetingPreset || undefined}
        data={[{ targetingTermValues }]}
      />
    </div>
  );
};

export default TargetingPresetDetails;
